import { nanoid } from 'nanoid';
import React, { useRef, useState } from 'react';
import NumberFormat from 'react-number-format';

import TextInput, { TextInputPropsSingleLine } from 'product_modules/components/TextInput';
import { NOT_DIGITS_REGEX } from 'utils/curo-helpers/validation';

import styles from './SSNInput.module.scss';

type SSNInputProps = Omit<
  TextInputPropsSingleLine,
  'value' | 'onChange' | 'ref' | 'defaultValue' | 'type' | 'name' | 'id' | 'autoComplete'
> & {
  value: string;
  onChange: (value: string) => void;
  ssnFormat?: string;
};

const SSN_FORMAT = '###-##-####';
const SSN_MASK = 'X';

export const SSNInput = ({ value, onChange, onBlur, onFocus, ssnFormat = SSN_FORMAT, ...props }: SSNInputProps) => {
  const [displayValue, setDisplayValue] = useState<string>(value);

  const handleChange = (values: { value: string; formattedValue: string }) => {
    setDisplayValue(values.formattedValue);
    onChange(values.value.replace(NOT_DIGITS_REGEX, ''));
  };

  //Unique autoComplete value to prevent browser from autofilling the field
  const uniqueId = useRef(nanoid());

  return (
    <NumberFormat
      format={ssnFormat}
      mask={SSN_MASK}
      value={displayValue}
      onValueChange={handleChange}
      onBlur={onBlur}
      onFocus={onFocus}
      customInput={TextInput}
      tooltipClassName={styles.tooltipWrapper}
      name={uniqueId.current}
      id={uniqueId.current}
      autoComplete={uniqueId.current}
      {...props}
    />
  );
};

export default SSNInput;
